var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 10,
    height: 40,
    fill: "#a60808"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -0.6
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 10,
    height: 40,
    fill: "#a60808"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -0.4
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 30,
    width: 10,
    height: 40,
    fill: "#a60808"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -0.2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 30,
    width: 10,
    height: 40,
    fill: "#a60808"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
    values: "1;0.2;1",
    begin: -1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/Bars.705cbe2c6e692d2ee24bb3362fe1efc4.svg";
export { ForwardRef as ReactComponent };